// 2026년 MLSRD 진단검사 결과지.
// 2025년 결과지(result.js, views/result/student·teacher·principal)는 그대로 두고,
// 2026 버전은 별도 디렉터리(views/result/MLSRD-2026)/라우트로 분리한다. (AI 리터러시 2026과 같은 방식)
import ResultIndex from '@/views/result/MLSRD-2026/index.vue';
import ResultTeacher from '@/views/result/MLSRD-2026/teacher/index.vue';
import ResultStudent from '@/views/result/MLSRD-2026/student/index.vue';
import ResultPrincipal from '@/views/result/MLSRD-2026/principal/index.vue';
import ResultStatus from '@/views/result/MLSRD-2026/teacher/Status.vue';
import ResultAnalysis from '@/views/result/MLSRD-2026/principal/Analysis.vue';

const routes = [
  {
    path: "/result/mlsrd-2026",
    component: ResultIndex,
    meta: { title: "검사 결과" },
    children: [
      {
        path: "teacher",
        name: "ResultTeacher2026",
        component: ResultTeacher,
        meta: { title: "교사 검사 결과" },
      },
      {
        path: "student",
        name: "ResultStudent2026",
        component: ResultStudent,
        meta: { title: "학생 검사 결과" },
      },
      {
        path: "principal/:schoolType?",
        name: "ResultPrincipal2026",
        component: ResultPrincipal,
        props: true,
        meta: { title: "교장 검사 결과" },
      },
      {
        path: "teacher/status",
        name: "ResultStatus2026",
        component: ResultStatus,
        meta: { title: "교사 검사 상태" },
      },
      {
        path: "principal/analysis",
        name: "ResultAnalysis2026",
        component: ResultAnalysis,
        meta: { title: "교장 검사 분석" },
      },
      {
        path: "principal/:schoolType?/analysis",
        name: "ResultAnalysisElementary2026",
        component: ResultAnalysis,
        props: true,
        meta: { title: "교장 검사 분석" },
      },
    ]
  },
];

export default routes;
